import SectionWrapper from '@/components/feature/SectionWrapper';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="bg-boxing-darker py-16 md:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <SectionWrapper className="text-center mb-12 md:mb-16">
          <span className="section-label">/ Student Results</span>
          <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            Proven <span className="text-highlight">Transformations</span>
          </h2>
          <div className="w-16 h-[2px] bg-boxing-red mx-auto mt-6" />
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 items-center">
          {testimonials.map((t, index) => {
            const isCenter = index === 1;
            return (
              <SectionWrapper key={t.id} delay={index * 120}>
                <div
                  className={`rounded-xl p-6 md:p-7 h-full transition-all duration-300 ${
                    isCenter
                      ? 'bg-boxing-black border border-boxing-red/30 shadow-[0_0_30px_rgba(255,30,30,0.08)] scale-100 md:scale-105 z-10'
                      : 'bg-boxing-black/50 border border-white/5 opacity-80 hover:opacity-100 hover:bg-boxing-black/70'
                  }`}
                >
                  {/* Stars */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-boxing-red text-sm" />
                      </span>
                    ))}
                  </div>

                  {/* Quote */}
                  <p className={`leading-[1.75] italic mb-5 ${isCenter ? 'text-white/90 text-sm' : 'text-white/60 text-sm'}`}>
                    &ldquo;{t.text}&rdquo;
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-11 h-11 rounded-full object-cover border border-white/10"
                    />
                    <div>
                      <p className={`font-oswald text-sm uppercase tracking-wider ${isCenter ? 'text-white' : 'text-white/70'}`}>
                        {t.name}
                      </p>
                      <p className="text-boxing-textgray text-xs">{t.role}</p>
                    </div>
                  </div>
                </div>
              </SectionWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}